import { useSelection } from '../lib/selection';
import { useData } from '../lib/data';
import { Home } from '../views/Home';
import { ClientDashboard } from '../views/ClientDashboard';
import { ProjectView } from '../views/ProjectView';
import { TaskView } from '../views/TaskView';
import { MyTasks } from '../views/MyTasks';
import { UptimeView } from '../views/UptimeView';
import { Deleted } from '../views/Deleted';
import { Completed } from '../views/Completed';
import { Contacts } from '../views/Contacts';
import { PipelinesView } from '../views/PipelinesView';

// Renders whichever view matches the current sidebar selection.
export function DetailPane() {
  const { selection } = useSelection();
  const { loading } = useData();

  if (loading) {
    return (
      <div className="flex-1 grid place-items-center text-dim font-mono text-sm">
        loading workspace…
      </div>
    );
  }

  switch (selection.type) {
    case 'home':
      return <Home />;
    case 'my-tasks':
      return <MyTasks />;
    case 'uptime':
      return <UptimeView />;
    case 'deleted':
      return <Deleted />;
    case 'completed':
      return <Completed />;
    case 'contacts':
      return <Contacts />;
    case 'pipelines':
      return <PipelinesView />;
    case 'client':
      return <ClientDashboard slug={selection.slug} />;
    case 'project':
      return <ProjectView slug={selection.slug} />;
    case 'task':
      return <TaskView taskId={selection.id} />;
  }
}
